import get from "lodash/get";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leavename: "",
  leaveid: null,
  maxleave: 0,
  maxleavedurationtypeid: { displayname: "Month", displayvalue: 1 },
  maxconsecutiveleave: 0,
  maxconsecutiveleavedurationtypeid: null,
  isallowhalfday: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 1,
  notifynotbeforeday: 2,
  apppastday: 0,
  isfurtureappallowed: false,
  ispastappallowed: false,
};
class NameUsagePolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
      durationSlab: [
        { displayname: "Month", displayvalue: 1 },
        { displayname: "Quarter", displayvalue: 2 },
      ],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.SetValues(props);
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      leavename: this.state.leavename,
      maxleave: this.state.maxleave,
      maxconsecutiveleave: this.state.maxconsecutiveleave,
      maxleavedurationtypeid: this.state.maxleavedurationtypeid
        ? this.state.maxleavedurationtypeid.displayvalue
        : null,
      maxconsecutiveleavedurationtypeid: this.state
        .maxconsecutiveleavedurationtypeid
        ? this.state.maxconsecutiveleavedurationtypeid.displayvalue
        : null,
      isallowhalfday: this.state.isallowhalfday,
      minleavecountforapp: this.state.minleavecountforapp,
      notifyinadvanceday: this.state.notifyinadvanceday,
      notifynotbeforeday: this.state.notifynotbeforeday,
      apppastday: this.state.apppastday,
      isfurtureappallowed: this.state.isfurtureappallowed,
      ispastappallowed: this.state.ispastappallowed,
    };
    // InitLeavesPolicy.details = InitLeavesPolicy.policy;
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const InitLeavesPolicy = props.InitLeavesPolicy.policy[ParentIndex];
      this.setState({
        leavename: InitLeavesPolicy.leavename,
        ParentIndex,
        leavetypeid: props.leavetypeid,
        maxleave: InitLeavesPolicy.maxleave,
        maxconsecutiveleave: InitLeavesPolicy.maxconsecutiveleave,
        isallowhalfday: InitLeavesPolicy.isallowhalfday,
        minleavecountforapp: InitLeavesPolicy.minleavecountforapp,
        notifyinadvanceday: InitLeavesPolicy.notifyinadvanceday,
        notifynotbeforeday: InitLeavesPolicy.notifynotbeforeday,
        apppastday: InitLeavesPolicy.apppastday,
        isfurtureappallowed: InitLeavesPolicy.isfurtureappallowed,
        ispastappallowed: InitLeavesPolicy.ispastappallowed,
        maxleavedurationtypeid: InitLeavesPolicy.maxleavedurationtypeid
          ? this.state.durationSlab.find(
              (x) => x.displayvalue == InitLeavesPolicy.maxleavedurationtypeid,
            )
          : null,
      });
    } else {
      const parentIndex = props.ParentIndex || 0;
      const name = get(props, `InitLeavesPolicy.details[${parentIndex}]`, "");
      this.setState({
        ...ParentState,
        leavename: name && get(name, "leavetypename", ""),
      });
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "maxconsecutiveleavedurationtypeid":
      case "maxleavedurationtypeid":
      case "isallowhalfday":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 1,
            notifynotbeforeday: 2,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      default:
        break;
    }
  }

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => {
        this.UpdateReducer();
      });
    }
  };

  checkUnique() {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    const { ParentIndex, leavename } = this.state;
    if (leavename || leavename != "") {
      if (
        leavename.includes("employeename") ||
        leavename.includes("employeecode") ||
        leavename.includes("designation") ||
        leavename.includes("department") ||
        leavename.includes("businessunit")
      ) {
        enqueueSnackbar("Please enter valid leave name", {
          variant: "error",
        });
        this.setState({ notUnique: true }, () => {
          if (
            this.props.InitLeavesPolicy.policy[ParentIndex] &&
            this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
          ) {
            this.UpdateReducer();
          }
        });
      } else if (
        this.props.InitLeavesPolicy.policy[ParentIndex]
            && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
      ) {
        this.UpdateReducer();
      } else {
        instance
          .post("/leaves/uniqueleavename", {
            leavename,
            leavetypeid: InitLeavesPolicy.details[ParentIndex].leavetypeid,
            leavecategoryid:
              InitLeavesPolicy.details[ParentIndex].leavecategoryid,
            leaveid: this.props.InitLeavesPolicy.policy[ParentIndex]
              ? this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
              : null,
          })
          .then(() => {
            this.setState({ notUnique: false }, () => this.UpdateReducer());
          })
          .catch((error) => {
            this.setState({ notUnique: true });
            enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              {
                variant: "error",
              },
            );
          });
      }
    } else {
      this.setState({ notUnique: true }, () => {
        if (
          this.props.InitLeavesPolicy.policy[ParentIndex] &&
          this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
        ) {
          this.UpdateReducer();
        }
      });
    }
  }

  onNameChange(event) {
    this.setState({ leavename: event.target.value }, () => {
      this.UpdateReducer();
    });
    if (this.props.ChangeSteppername) {
      this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
    }
  }

  validateNext() {
    this.checkUnique();
    if (!this.state.leavename || this.state.leavename == "") {
      this.setState({ notUnique: true });
    } else {
      this.props.click();
    }
  }

  render() {
    const language = this.props.Language.extratimepolicy;
    const isMonthSelected =
      this.state.maxleavedurationtypeid &&
      this.state.maxleavedurationtypeid == 1;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <div className="inner-wrapper opaque">
            <div className="form-group">
              <p className="form-main-header">
                <FormattedMessage
                  id="LbleaveName"
                  defaultMessage="Let’s give this leave a name"
                />
              </p>
              <div>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  maxLength={50}
                  // autoFocus
                  placeholder="Leave Name"
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.leavename}
                  onBlur={this.checkUnique.bind(this)}
                />
                <br />
                {this.state.notUnique ? (
                  <span className="caption-error leave-policy-error">
                    *Please select a unique name
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          {/* 1 */}
          {/* <div>
            <p class="form-main-header">
              <FormattedMessage id="LbUsagePolicy" defaultMessage="Usage Policy" />
            </p>
            <p class="form-sub-header">
              <FormattedMessage
                id="LbConfigureLeaveUsage"
                defaultMessage="Now, let’s configure the leave usage policy below"
              />
            </p>
            <div className="inner-wrapper opaque">
              <p class="depedent-select-list-head">
                <FormattedMessage id="LbLeaveUsageLimits" defaultMessage="Leave Usage Limits" />
              </p>
              <div>
                <span class="floatleft padding-right-16 padding-top-8">In a </span>
                <span class="width113p">
                  <Select
                    autofocus
                    placeholder="Select"
                    options={this.state.durationSlab}
                    getOptionLabel={option => option.displayname}
                    getOptionValue={option => option.displayvalue}
                    onChange={this.handleChange.bind(this, "maxleavedurationtypeid")}
                    value={this.state.maxleavedurationtypeid}
                    style={{ marginTop: 15 }}
                    className="width58"
                  />
                </span>
                <br />
                <FormattedMessage id="__LbAllowMax" defaultMessage="allow only a maximum of " />
                <InputValues
                  min="1"
                  max="100"
                  field="maxleave"
                  onChange={e => this.CommonNumberChange("maxleave", 100, e)}
                  value={this.state.maxleave}
                  defaultvalue={this.state.maxleave}
                />
                <FormattedMessage id="LbDaysLeave" defaultMessage="days leave in a  " />
                <br />
              </div>
              <div>
                <FormattedMessage
                  id="LbAllowMaxConse"
                  defaultMessage="Allow only a maximum consecutive "
                />
                <InputValues
                  min="1"
                  max="366"
                  field="maxconsecutiveleave"
                  max={this.state.maxleave}
                  onChange={this.CommonNumberChange.bind(this, "maxconsecutiveleave", 366)}
                  value={this.state.maxconsecutiveleave}
                  defaultvalue={this.state.maxconsecutiveleave}
                />
                <FormattedMessage id="LbDays" defaultMessage="days" />
              </div>
            </div>
          </div> */}

          {/** start */}
          <p className="form-sub-header">
            <p className="form-main-header">
              <FormattedMessage
                id="LbUsagePolicy"
                defaultMessage="Usage Policy"
              />
            </p>
            <FormattedMessage
              id="__LbLeaveUsageLimits"
              defaultMessage="Lets configure the leave usage limits"
            />
          </p>
          <div className="inner-wrapper opaque margin-top-10">
            <div>
              <div>
                <span className="floatleft margin-right-10 margin-top-16">
                  In a{" "}
                </span>
                <span className="floatleft width25 margin-top-8 margin-right-8">
                  <Select
                    autofocus
                    placeholder="Select"
                    options={this.state.durationSlab}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.handleChange.bind(
                      this,
                      "maxleavedurationtypeid",
                    )}
                    value={this.state.maxleavedurationtypeid}
                    style={{ marginTop: 15 }}
                  />
                </span>
                <span>
                  <FormattedMessage
                    id="__LbAllowOnlyMax"
                    defaultMessage="allow only a maximum of"
                  />
                  <InputValues
                    min="0"
                    max={isMonthSelected ? "28" : "90"}
                    field="maxleave"
                    onChange={(e) =>
                      this.CommonNumberChange("maxleave", 100, e)
                    }
                    value={this.state.maxleave}
                    defaultvalue={this.state.maxleave}
                  />
                  <FormattedMessage
                    id="__LbDaysInAmonthorquarter"
                    defaultMessage="days leaves "
                  />
                </span>
              </div>
              <br />
            </div>
          </div>

          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="__LbAllowOnlyMaxConsecutive"
                defaultMessage="How many maximum consecutive leaves you want to allow?"
              />
            </p>
            <InputValues
              min="0"
              max="365"
              field="maxconsecutiveleave"
              // max={this.state.maxleave}
              onChange={this.CommonNumberChange.bind(
                this,
                "maxconsecutiveleave",
                366,
              )}
              value={this.state.maxconsecutiveleave}
              defaultvalue={this.state.maxconsecutiveleave}
            />
            <FormattedMessage id="LbDays" defaultMessage="days" />
          </div>
          {/** end */}
          {/* 2 */}
          <div className="inner-wrapper margin-top-20 opaque">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbAllowHalfDayApplication"
                defaultMessage="Would you like to allow half-day leave applications?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", true)}
              aria-expanded={this.state.isallowhalfday == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isallowhalfday == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", false)}
              aria-expanded={this.state.isallowhalfday == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isallowhalfday == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 3 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLimitFutureApplications"
                defaultMessage="Do you want to limit leave applications for future dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", true)}
              aria-expanded={this.state.isfurtureappallowed == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isfurtureappallowed == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isfurtureappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbLeaveDurationGreater"
                  defaultMessage="If leave duration is greater than"
                />
                <InputValues
                  min="0"
                  max="365"
                  field="minleavecountforapp"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "minleavecountforapp",
                    365,
                  )}
                  value={this.state.minleavecountforapp}
                  defaultvalue={this.state.minleavecountforapp}
                />
                <span>days, </span>
                <br />
                <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifyinadvanceday",
                    365,
                  )}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                <span>days in advance,</span>
                <br />
                <FormattedMessage
                  id="__LbButNotEarlier1"
                  defaultMessage="but not earlier than"
                />
                <InputValues
                  min={
                    (this.state.notifyinadvanceday &&
                      parseInt(this.state.notifyinadvanceday) + 1) ||
                    2
                  }
                  max="300"
                  field="notifynotbeforeday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifynotbeforeday",
                    300,
                  )}
                  value={this.state.notifynotbeforeday}
                  defaultvalue={this.state.notifynotbeforeday || 2}
                />
                <FormattedMessage id="__LbDays" defaultMessage="days" />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", false)}
              aria-expanded={this.state.isfurtureappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isfurtureappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 4 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbPastApplications"
                defaultMessage="Do you want to allow leave application for past dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", true)}
              aria-expanded={this.state.ispastappallowed == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.ispastappallowed == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.ispastappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbApplMadeUpTo"
                  defaultMessage="Leave application can be made upto"
                />
                <InputValues
                  min="1"
                  max="90"
                  field="apppastday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "apppastday",
                    90,
                  )}
                  value={this.state.apppastday}
                  defaultvalue={this.state.apppastday}
                />
                <FormattedMessage
                  id="LbActualLeaveDate"
                  defaultMessage="days after actual leave date"
                />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", false)}
              aria-expanded={this.state.ispastappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.ispastappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
                        Next
                    </Button> */}
        </div>
      </IntlProvider>
    );
  }
}
NameUsagePolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(NameUsagePolicy)));
